const toFiniteMetricNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const numeric =
    typeof value === "number"
      ? value
      : Number(String(value).trim().replace(/[$,%\s,]/g, ""));
  return Number.isFinite(numeric) ? numeric : null;
};

export const formatSherlocCurrency = (value, missingLabel = "No Data") => {
  const numeric = toFiniteMetricNumber(value);
  if (numeric === null) return missingLabel;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numeric);
};

export const hasSherlocMetricValue = (value) => toFiniteMetricNumber(value) !== null;
